/**
 * 日记。两类，界线是本项目的一条红线：
 *
 *   RelationshipDiary  「我和你的今天」——挂在关系上，属于某个具体用户
 *   CharacterDiary     「她自己的今天」——跨用户共享，**表结构上就没有 userId**，
 *                       且有 CHECK (deidentified = true)
 *
 * 角色日记页因此不提供任何用户维度的筛选。不是查不到，而是一旦这里开了口子，
 * 下一个人就会给表加字段。
 */

import { Alert, Card, DatePicker, Input, Space, Typography } from "antd";
import { Link } from "react-router-dom";
import { DataTable, useTableParams } from "../../components/DataTable";
import { useCharacterScope } from "../../services/character";
import { fmtNumber, StatusTag, Tags } from "../../components/format";


const REL_FILTERS = ["search", "from", "to"];

export function RelationshipDiariesPage() {
  const { searchParams, setParam } = useTableParams(REL_FILTERS);
  const scope = useCharacterScope();
  return (
    <DataTable
      title="关系日记 · 我和你的今天"
      path="/api/v1/admin/diaries/relationship"
      fixedParams={scope}
      filterKeys={REL_FILTERS}
      toolbar={
        <Space wrap>
          <Input.Search
            allowClear
            style={{ width: 300 }}
            placeholder="标题 / 摘要 / 标签"
            defaultValue={searchParams.get("search") ?? ""}
            onSearch={(v) => setParam("search", v)}
          />
          <DatePicker
            placeholder="起始日期"
            onChange={(d) => setParam("from", d ? d.format("YYYY-MM-DD") : undefined)}
          />
          <DatePicker
            placeholder="结束日期"
            onChange={(d) => setParam("to", d ? d.format("YYYY-MM-DD") : undefined)}
          />
        </Space>
      }
      columns={[
        { title: "日期", dataIndex: "date", width: 110 },
        {
          title: "用户",
          dataIndex: "userName",
          width: 130,
          render: (v: string | null, r: { userId: string }) => <Link to={`/users/${r.userId}`}>{v || "—"}</Link>,
        },
        { title: "标题", dataIndex: "title", width: 200, render: (v) => v || "—" },
        { title: "摘要", dataIndex: "summary", render: (v) => v || "—" },
        { title: "标签", dataIndex: "tags", width: 180, render: (v: string[]) => <Tags values={v} /> },
        { title: "记忆标签", dataIndex: "memoryTags", width: 160, render: (v: string[]) => <Tags values={v} /> },
        { title: "好感快照", dataIndex: "characterAffinitySnapshot", width: 90, align: "right" },
        { title: "消息", dataIndex: "messageCount", width: 70, align: "right" },
        { title: "token", dataIndex: "tokenCount", width: 90, align: "right", render: fmtNumber },
        { title: "状态", dataIndex: "status", width: 90, render: (v) => <StatusTag value={v} /> },
        {
          title: "关系",
          dataIndex: "relationshipId",
          width: 100,
          render: (v: string) => <Link to={`/users/${v}`}>{v.slice(-8)}</Link>,
        },
      ]}
    />
  );
}
